import { isAfter } from 'date-fns';
import { parseDate } from '@purple-start-registration/common/dates';

let config = undefined;

async function loadConfig() {
  const res = await fetch(
    'https://purplestart.blob.core.windows.net/data/config.json?t=' +
      new Date().getTime()
  );

  const { status, statusText } = res;
  if (status === 200) {
    return await res.json();
  } else {
    console.error(`Failed to load configuration (${status} ${statusText})`);
    throw new Error(`Failed to load configuration (${status} ${statusText})`);
  }
}

export async function getConfig(section) {
  if (!section) {
    return null;
  }

  if (!config) {
    config = await loadConfig();
  }

  const configSection = config.sections[section];
  if (!configSection) {
    throw new Error(`Config section ${section} not found`);
  }

  function getTranslation(key, language) {
    return (
      configSection.translations &&
      configSection.translations[`${key}_${language}`]
    );
  }

  // Event has a list of events.
  if (configSection.type === 'event') {
    return {
      type: configSection.type,
      settings: {
        ...config.settings,
        ...configSection.settings,
      },
      getTranslation,
      events: configSection.event_list
        .map((event) => ({
          ...event,
          date: parseDate(event.date),
          dateISO: event.date,
        }))
        .filter((event) => isAfter(event.date, new Date())),
    };
  }

  // Session has support for sessions and full months.
  if (configSection.type === 'session') {
    return {
      type: configSection.type,
      settings: {
        ...config.settings,
        ...configSection.settings,
      },
      getTranslation,
      sessions: configSection.session_dates
        .map((session) => ({
          ...session,
          date: parseDate(session.date),
          dateISO: session.date,
        }))
        .filter((session) => isAfter(session.date, new Date())),
      months: configSection.session_months.map((monthISO) => ({
        date: parseDate(monthISO),
        dateISO: monthISO,
      })),
    };
  }

  throw new Error(`Config type missing or unknown: ${configSection.type}`);
}
